import React from "react";
import { Routes, Route } from "react-router-dom";
import { Outlet } from "react-router";
import { useSelector } from "react-redux";

import routes from "../../../system/routes";
import SideBarContainer from "../../../shared/components/SideBarContainer/SideBarContainer";
import NotFound from "../../views/notFound/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import { roles } from "../../../constants";
import { AdminRoutes } from "../../../modules/AdminPortal/AdminRoutes";
import { CustomerRoutes } from "../../../modules/CustomerPortal/CustomerRoutes";
import { SuperAdminRoutes } from "../../../modules/AdminPortal/SuperAdminRoutes";
import { InstructorRoutes } from "../../../modules/InstructorPortal/InstructorRoutes";
import { PractitionerRoutes } from "../../../modules/PractitionerPortal/PractitionerRoutes";
import NavBar from "../../../shared/components/NavBar/NavBar";
import { CenterInstructorRoutes } from "../../../modules/InstructorPortal/CenterInstructorRoutes";
import { CenterRoutes } from "../../../modules/CenterPortal/CenterRoutes";

const RouterWrapper = (props) => {
  const isAuthenticated = useSelector(
    (state) => state.LoginReducer.isAuthenticated
  );
  const UserData = useSelector((state) => state.LoginReducer.UserData);

  const updatedRoutes = routes.map((route) => {
    // Check if the route needs its protected property updated
    if (route.updateProtected) {
      return {
        ...route,
        protected: isAuthenticated,
        hasSideBar: isAuthenticated,
      };
    }
    // Keep the other routes unchanged
    return route;
  });

  let allRoutes = [...updatedRoutes];
  if (isAuthenticated) {
    if (UserData?.user?.role === roles.SuperAdmin) {
      allRoutes = [...allRoutes, ...SuperAdminRoutes];
    } else if (UserData?.user?.role === roles.Admin) {
      allRoutes = [...allRoutes, ...AdminRoutes];
    } else if (UserData?.user?.role === roles.Center) {
      allRoutes = [...allRoutes, ...CenterRoutes(UserData)];
    } else if (
      UserData?.user?.role === roles.FreelanceInstructor ||
      (UserData?.user?.role === roles.Instructor &&
        UserData.instructorCenterId !== null)
    ) {
      allRoutes = [...allRoutes, ...CenterInstructorRoutes];
    } else if (UserData?.user?.role === roles.Instructor) {
      allRoutes = [...allRoutes, ...InstructorRoutes];
    } else if (
      UserData?.user?.role === roles.Practioner ||
      UserData?.user?.role === roles.VerifiedUser
    ) {
      allRoutes = [...allRoutes, ...PractitionerRoutes];
    } else {
      allRoutes = [...allRoutes, ...CustomerRoutes];
    }
  }

  const transformedRoutes = (
    <>
      {allRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            <ProtectedRoute isProtected={route.protected}>
              {route.hasSideBar ? (
                <SideBarContainer element={route.component} />
              ) : (
                <div className="sidebarcontainerDiv">
                  <NavBar hideProfileIcon={true} />
                  {route.component}
                </div>
              )}
   
            </ProtectedRoute>
          }
        />
      ))}
    </>
  );

  return (
    <Routes>
      <Route path="/" element={<Outlet />}>
        {transformedRoutes}
        <Route path="*" element={<NotFound />}></Route>
      </Route>
    </Routes>
  );
};

export default RouterWrapper;
